import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import {PeriodTypeStringMap, SubscriptionStatus} from '@web/core/constants'
import makeSlice from '@web/slices/admissionDetail/sliceMaker'

const admissionDetailSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload}) => {
            const {
                firstDeliveryDate,
                firstPaymentDate,
                periodType,
                deliveryId,
                scheduleId,
                periodCount,
                nextPaymentDate,
                immediatelyPaymentSuccess,
            } = payload.subscriptionResultViewInfo.subscriptionApplicationView

            // 즉시결제 케이스에는 다음 (2회차) 결제일을 노출한다
            const nextPaymentDateTime = immediatelyPaymentSuccess ? (nextPaymentDate ?? '') : firstPaymentDate

            state.usedPaymentMethod.subscription = {
                /** 신청완료 페이지는 무조건 구독 1회차 */
                round: 1,
                /** 구독 id (배송 id) */
                id: String(deliveryId),
                /** 배송주기 */
                period: PeriodTypeStringMap[periodType],
                /** 다음 배송희망일 */
                nextDeliveryDateTime: firstDeliveryDate,
                /** 다음 결제예정일 */
                nextPaymentDateTime,
                /** 배송회차 */
                scheduleId,
                /** 전체 회차 */
                totalRound: periodCount,
                /** 사용 안함 */
                registerDateTime: '',
                /** 사용 안함 */
                status: SubscriptionStatus.ACTIVE,
            }
        })
    },
})

export default admissionDetailSlice.reducer
